export const getEventListPageStrapiURL = (
  baseURL: string,
  locale?: string,
  slug?: string,
  citySlug?: string,
  categorySlug?: string
) => {
  const eventListPageURLQuery = new URL(
    'event-list-pages?' +
      'populate[showcase][populate][0]=first.image' +
      '&populate[showcase][populate][1]=second.image' +
      '&populate[showcase][populate][2]=third.image' +
      '&populate[horizontalCardList][populate]=image' +
      '&populate[giftcardSection][populate]=*' +
      '&populate[localizations]=*' +
      '&populate[seo][populate]=*' +
      '&populate[searchFilters][populate]=*',
    baseURL
  )
  // add slug for tag and teamevent pages
  slug && eventListPageURLQuery.searchParams.set('filters[slug][$eq]', slug)
  // set city slug for city and city category pages
  citySlug &&
    eventListPageURLQuery.searchParams.set('filters[citySlug][$eq]', citySlug)
  // set city slug for category and city category pages
  categorySlug &&
    eventListPageURLQuery.searchParams.set(
      'filters[categorySlug][$eq]',
      categorySlug
    )
  // set city slug as null to avoid city pages
  !citySlug &&
    eventListPageURLQuery.searchParams.set('filters[citySlug][$null]', 'true')
  // set category slug as null to avoid city pages
  !categorySlug &&
    eventListPageURLQuery.searchParams.set(
      'filters[categorySlug][$null]',
      'true'
    )
  eventListPageURLQuery.searchParams.set('locale', locale || 'all')

  return eventListPageURLQuery
}

export const getStrapiArticlesCategoryUrl = (
  baseURL: string,
  slug: string,
  locale: string
) => {
  const articlesCategoryURL = new URL(
    `categories?filters[slug][$eq]=${slug}` +
      `&locale=${locale}` +
      '&populate[summary_list][populate]=*' +
      '&populate[admin_user]=*' +
      '&populate[articles][populate][0]=header_image' +
      '&populate[articles][populate][1]=admin_user' +
      '&populate[header_image]=*' +
      '&populate[seo]=*',
    baseURL
  )

  return articlesCategoryURL
}

export const getStrapiPageURL = (
  baseURL: string,
  locale: string,
  slug: string
) => {
  const pageURL = new URL(`pages?populate[contents][populate]=*`, baseURL)
  slug && pageURL.searchParams.set('filters[slug][$eq]', slug)
  pageURL.searchParams?.set('locale', locale || 'all')

  // ?populate[contents][populate]=*
  // ?populate[shared.carousel][populate][items][populate]=*&populate[title]=*&populate[CTA]=*
  // GET /api/teamevents?populate[carousel][populate][items][populate]=*&populate[title]=*&populate[CTA]=*
  // &populate[contents][on][shared.carousel][populate]=image
  return pageURL
}
